import loadable from '@loadable/component';

export const CodeEditor = loadable(() =>
  import(/* webpackChunkName: "code-editor" */ './CodeEditor').then(
    module => module.CodeEditor,
  ),
);
